(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('weekschemeHead', ['DayschemeTimesService', WeekschemeHeadDirectiveFn]);

    function WeekschemeHeadDirectiveFn(DayschemeTimesService) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                weekday: '='
            },
            templateUrl: '/app/settings/agendasettings/modules/weekschemes/templates/weekscheme-head.template.html'
        };
        return directive;

        function link(scope, element) {

            var copy = element.find('#copy');
            var close = element.find('#close');
            var paste = element.find('#paste');

            // functions

            // select day
            scope.selectDay = DayschemeTimesService.selectDay;

            // copy and paste actions
            scope.prepareForCopy = DayschemeTimesService.prepareForCopy;
            scope.paste = DayschemeTimesService.paste;
            scope.stopCopy = DayschemeTimesService.stopCopy;

            // stop copy progress
            scope.stopCopy = function () {
                DayschemeTimesService.stopCopy(scope.weekday);
                hide(close);
            };

            // start copy progress
            scope.prepareForCopy = function () {
                DayschemeTimesService.prepareForCopy(scope.weekday);
                hide(copy);
                show(close);
            };

            element.on('mouseenter', function (event) {
                if (!showable()) {

                    // show paste or close
                    if (scope.weekday.vmCopyInProgress) {
                        show(close);
                    } //if
                    else if (scope.weekday.vmPastePossible) {
                        show(paste);
                    } //else if
                } //if
                else {
                    // show copy icon
                    show(copy);
                } // else
            });

            element.on('mouseleave', function (event) {
                hide(copy);
                hide(paste);
            });


            function show(el) {
                el.removeClass('hide');
                el.addClass("show");
            }

            function hide(el) {
                el.removeClass('show');
                el.addClass("hide");
            }

            // can we show the copy - icon on hover
            function showable() {
                return scope.weekday.vmCopyInProgress === false && scope.weekday.vmPastePossible === false;
            }


            // on destroy
            scope.$on('$destroy', function () {
                element.off('mouseenter');
                element.off('mouseleave');
                copy = null;
                paste = null;
                close = null;
            });

        }
    }

})();